import React from 'react';
import { Chip } from '@mui/material';

const DefaultRoleBadge = ({ role }) => {
  if (!role?.is_default) return null;

  return (
    <Chip size='small' label='Default' color='primary' variant='outlined' />
  );
};

export default DefaultRoleBadge;
